import type { TokenizedUser } from "@/utils/types"
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { jwtDecode } from "jwt-decode"

type AuthState = {
  token: string | null
  user: TokenizedUser | null
}

let token: string | null = null
let user: TokenizedUser | null = null

if (typeof window !== "undefined") {
  token = localStorage.getItem("token")
  try {
    if (token) user = jwtDecode<TokenizedUser>(token)
  } catch (err) {
    console.error("Invalid token in localStorage", err)
    token = null
  }
}

const initialState: AuthState = {
  token,
  user,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth(state, action: PayloadAction<{ token: string }>) {
      state.token = action.payload.token
      localStorage.setItem("token", action.payload.token)

      const decoded: TokenizedUser = jwtDecode(action.payload.token)
      state.user = decoded
    },
    logout(state) {
      state.token = null
      localStorage.removeItem("token")
      state.user = null
    },
  },
})

export const { setAuth, logout } = authSlice.actions
export default authSlice.reducer
